import { Link } from 'react-router-dom';

/**
 * Shared auth-page shell: deep navy backdrop with soft gold + sky glows
 * and a subtle dot texture — matches the marketing site brand.
 * Renders an oversized brand mark on top of the card so the logo has
 * proper visual weight without competing with the form.
 */
export const AuthLayout = ({ children }) => {
  return (
    <div className="relative min-h-screen bg-[#070d1c] text-slate-100 flex items-center justify-center px-4 py-10 overflow-hidden">
      {/* Ambient background ornaments — same DNA as the marketing hero */}
      <div className="pointer-events-none absolute inset-0" aria-hidden="true">
        <div className="absolute -top-32 -left-32 h-[480px] w-[480px] rounded-full bg-amber-400/10 blur-3xl" />
        <div className="absolute top-1/3 -right-40 h-[520px] w-[520px] rounded-full bg-sky-500/15 blur-3xl" />
        <div className="absolute -bottom-40 left-1/2 -translate-x-1/2 h-[400px] w-[900px] rounded-full bg-blue-600/10 blur-3xl" />
        <div
          className="absolute inset-0 opacity-[0.05]"
          style={{
            backgroundImage:
              'radial-gradient(circle at 1px 1px, rgba(202,170,98,0.7) 1px, transparent 0)',
            backgroundSize: '32px 32px',
          }}
        />
        {/* thin heraldic gold hairlines top+bottom of viewport */}
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-amber-300/40 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-amber-300/40 to-transparent" />
      </div>

      <div className="relative w-full max-w-md">
        {/* Brand mark above the card */}
        <div className="flex flex-col items-center mb-6">
          <Link to="/" className="group" data-testid="auth-logo-link">
            <div className="relative">
              <div className="absolute -inset-3 bg-gradient-to-br from-amber-300/30 via-sky-400/20 to-blue-500/20 rounded-3xl blur-xl group-hover:blur-2xl transition-all" />
              <img
                src="/logo.png"
                alt="PROP VEIW"
                className="relative w-32 h-32 sm:w-36 sm:h-36 object-contain rounded-2xl bg-white/95 p-2 ring-1 ring-amber-300/40 shadow-2xl"
                data-testid="auth-logo"
              />
            </div>
          </Link>
          <h1 className="mt-4 font-manrope font-bold text-2xl sm:text-3xl tracking-tight text-white">
            PROP VEIW
          </h1>
          <div className="mt-2 flex items-center gap-3" aria-hidden="true">
            <span className="h-px w-10 bg-gradient-to-r from-transparent to-amber-300/60" />
            <span className="w-1.5 h-1.5 rotate-45 bg-amber-300/80" />
            <span className="h-px w-10 bg-gradient-to-l from-transparent to-amber-300/60" />
          </div>
        </div>

        {children}
      </div>
    </div>
  );
};

export default AuthLayout;
